<div class="background pb-5">
  <div class="container text-center pt-3 sb-router-outlet__no-header">
    <img src="https://springbot-assets.s3.us-east-1.amazonaws.com/images/logo-springbot-send.svg" class="sb-logo pt-5">
    <h2 class="my-5">
      Redirecting to your marketing dashboard.
    </h2>
    <fa-icon [icon]="['fas', 'cog']" [spin]="true" size="2x" class="primary-blue-color"></fa-icon>
  </div>
</div>
